import { runWithAdal } from 'react-adal';
import azureAd from './config/azureAd';

const DO_NOT_LOGIN = false;

runWithAdal(
  azureAd.authContext,
  () => {
    // eslint-disable-next-line
    require('./indexApp.js');
  },
  DO_NOT_LOGIN
);
